import { createGlobalStyle } from 'styled-components';

const Typography = createGlobalStyle`
  /* Typography styles are now handled in GlobalStyle.js */
  /* This file is kept for backward compatibility but is essentially empty */
`;

export default Typography;
